const translations = {
  en: {
    title: 'Express deposit',
    moreMethods: 'MORE DEPOSIT METHODS',
    withdrawalOptions: 'WITHDRAWAL OPTIONS',
    exp: 'Exp XX/',
    min: 'Min',
    max: 'Max',
    noLimit: 'No Limit',
    currency: 'Currency',
    amount: 'AMOUNT',
    deposit: 'DEPOSIT',
    depositStatus: 'Deposit Status',
    warning: 'Warning',
    error: 'Error',
    methodRequired: 'Deposit method required',
    amountRequired: 'Amount required',
    errorMakingDeposit: 'Error making deposit',
    errorGettingLimits: 'Error getting express deposit limits info: ',
    transactionID: 'TransactionID:',
    send: 'Send',
    toThisAddress: 'to this address:',
  },
  es: {
    title: 'Depósito Express',
    moreMethods: 'MÁS MÉTODOS DE DEPÓSITO',
    withdrawalOptions: 'OPCIONES DE RETIRO',
    exp: 'Vence XX/',
    min: 'Mín',
    max: 'Máx',
    noLimit: 'Sin Límite',
    currency: 'Moneda',
    amount: 'MONTO',
    deposit: 'DEPOSITAR',
    depositStatus: 'Estado del Depósito',
    warning: 'Advertencia',
    error: 'Error',
    methodRequired: 'Método de depósito requerido',
    amountRequired: 'Monto requerido',
    errorMakingDeposit: 'Error al realizar el depósito',
    errorGettingLimits: 'Error obteniendo información de límites del depósito express: ',
    transactionID: 'ID de Transacción:',
    send: 'Enviar',
    toThisAddress: 'a esta dirección:',
  },
  pt: {
    title: 'Depósito Express',
    moreMethods: 'MAIS MÉTODOS DE DEPÓSITO',
    withdrawalOptions: 'OPÇÕES DE SAQUE',
    exp: 'Val XX/',
    min: 'Mín',
    max: 'Máx',
    noLimit: 'Sem Limite',
    currency: 'Moeda',
    amount: 'VALOR',
    deposit: 'DEPOSITAR',
    depositStatus: 'Status do Depósito',
    warning: 'Aviso',
    error: 'Erro',
    methodRequired: 'Método de depósito obrigatório',
    amountRequired: 'Valor obrigatório',
    errorMakingDeposit: 'Erro ao realizar o depósito',
    errorGettingLimits: 'Erro ao obter informações dos limites de depósito express: ',
    transactionID: 'ID da Transação:',
    send: 'Enviar',
    toThisAddress: 'para este endereço:',
  },
}

export default translations
